import { render } from "./ModalNewContract.vue?vue&type=template&id=174d7be0&scoped=true&ts=true"
import script from "./ModalNewContract.vue?vue&type=script&lang=ts"
export * from "./ModalNewContract.vue?vue&type=script&lang=ts"

import "./ModalNewContract.vue?vue&type=style&index=0&id=174d7be0&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174d7be0"]])

export default __exports__